import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import {
  NARRATIVE_CREATED_LABEL,
  NARRATIVE_CREATED_LABEL_FADE_DURATION_MS,
  NARRATIVE_CREATING_LABEL,
} from '../../utilities/constants';

import styles from './_index.module.scss';

const NarrativeCreatedLabel = ({ isCompleted, isProcessing }) => {
  const [label, setLabel] = useState(
    isProcessing ? NARRATIVE_CREATING_LABEL : isCompleted ? NARRATIVE_CREATED_LABEL : null
  );
  const [isFading, setIsFading] = useState(false);
  const wasProcessingRef = useRef(isProcessing);

  useEffect(() => {
    if (isProcessing) {
      wasProcessingRef.current = true;
      setLabel(NARRATIVE_CREATING_LABEL);
      setIsFading(false);
      return undefined;
    }

    if (!isCompleted) {
      wasProcessingRef.current = false;
      setLabel(null);
      setIsFading(false);
      return undefined;
    }

    if (!wasProcessingRef.current) {
      setLabel(NARRATIVE_CREATED_LABEL);
      setIsFading(false);
      return undefined;
    }

    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      setLabel(NARRATIVE_CREATED_LABEL);
      setIsFading(false);
      wasProcessingRef.current = false;
      return undefined;
    }

    setIsFading(true);
    const timeoutId = window.setTimeout(() => {
      setLabel(NARRATIVE_CREATED_LABEL);
      setIsFading(false);
      wasProcessingRef.current = false;
    }, NARRATIVE_CREATED_LABEL_FADE_DURATION_MS);

    return () => window.clearTimeout(timeoutId);
  }, [isCompleted, isProcessing]);

  if (!label) return null;

  return (
    <div
      className={[styles['narrative-created-label'], isFading && styles['is-fading']]
        .filter(Boolean)
        .join(' ')}
      data-testid="chat-narrative-created-label"
    >
      <span
        className={isProcessing ? styles['is-processing'] : undefined}
        data-testid="chat-narrative-created-label-copy"
      >
        {label}
      </span>
    </div>
  );
};

NarrativeCreatedLabel.propTypes = {
  isCompleted: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool.isRequired,
};

export default NarrativeCreatedLabel;
